import { render } from "./ImportanceSymbol.vue?vue&type=template&id=1644c3c5"
import script from "./ImportanceSymbol.vue?vue&type=script&lang=js"
export * from "./ImportanceSymbol.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__